import { Colors } from "@snapchat/snap-design-system";
import { DotFilledIcon, type IconProps } from "@snapchat/snap-design-system-icons";

import { MyLensesAssetStatus } from "../../gql-generated/types";
import {
    StatusInReview,
    StatusProcessing,
    StatusPublished,
    StatusRejected,
    StatusUploadFailed,
} from "../components/messages.generated";

export interface AssetStatusDisplayMeta {
    name: React.ReactNode;
    color: Colors.ColorPalette;
    Icon: (props: IconProps) => React.JSX.Element;
}

const assetStatusMap: Record<MyLensesAssetStatus, AssetStatusDisplayMeta> = {
    [MyLensesAssetStatus.InReview]: { name: <StatusInReview />, color: Colors.Orange.V100, Icon: DotFilledIcon },
    [MyLensesAssetStatus.Published]: {
        name: <StatusPublished />,
        color: Colors.Green.V150,
        Icon: DotFilledIcon,
    },
    [MyLensesAssetStatus.Processing]: { name: <StatusProcessing />, color: Colors.Yellow.V200, Icon: DotFilledIcon },
    [MyLensesAssetStatus.Rejected]: { name: <StatusRejected />, color: Colors.Red.V100, Icon: DotFilledIcon },
    [MyLensesAssetStatus.UploadFailed]: { name: <StatusUploadFailed />, color: Colors.Gray.V250, Icon: DotFilledIcon },
};

// At runtime the backend can serve statuses this build doesn't know yet
// (deployed ahead of the frontend), so treat the map as partial.
const knownStatuses: Partial<Record<MyLensesAssetStatus, AssetStatusDisplayMeta>> = assetStatusMap;

export const getAssetStatusMeta = (status: MyLensesAssetStatus): AssetStatusDisplayMeta =>
    knownStatuses[status] ?? { name: status, color: Colors.Gray.V250, Icon: DotFilledIcon };
